export default "__VITE_ASSET__CQrasXaN__"